var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.76766 0.306022C1.36328 -0.102007 0.707659 -0.102007 0.303283 0.306022C-0.101094 0.714051 -0.101094 1.3756 0.303282 1.78362L2.50026 4.00045L0.304215 6.21633C-0.100161 6.62436 -0.100161 7.28591 0.304216 7.69393C0.708592 8.10196 1.36422 8.10196 1.76859 7.69394L4.69735 4.73873C5.10172 4.3307 5.10172 3.66915 4.69735 3.26112C4.68804 3.25173 4.6786 3.24255 4.66903 3.23359L1.76766 0.306022Z","fill":"currentColor"}));
}

Arrow.defaultProps = {"viewBox":"0 0 5 8"};

module.exports = Arrow;

Arrow.default = Arrow;
